// src/components/FilterButton.jsx
// 漏斗マークから開く絞り込み【2026-09-11】
//
// 絞り込みの入力欄を常に出しておくと場所を食うので、漏斗ボタンに畳む。
//
// ただし「畳んだせいで、絞り込まれていることに気づかない」のが一番まずい。
// 件数が少ないのがフィルタのせいなのか、本当にデータが無いのか分からなくなる。
// なので閉じているときでも、効いている条件は必ずボタンの隣にタグで出す。
// タグの × で1つずつ外せる。ボタンには効いている数をバッジで出す。

import React, { useEffect, useRef, useState } from 'react';
import Icon from './Icon';

export default function FilterButton({ chips = [], onReset, children, label = '絞り込み' }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  // 外側クリックと Esc で閉じる
  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    window.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      window.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const n = chips.length;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
      <div ref={wrapRef} style={{ position: 'relative' }}>
        <button
          type="button"
          className="btn-secondary"
          onClick={() => setOpen(v => !v)}
          aria-expanded={open}
          title={n ? label + '（' + n + '件が効いています）' : label}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.35rem',
            borderColor: n ? '#2563eb' : undefined,
            color:       n ? '#1d4ed8' : undefined,
            background:  n ? '#eff6ff' : undefined,
          }}
        >
          <Icon name="filter" size={16} />
          {label}
          {n > 0 && (
            <span style={{
              background: '#2563eb', color: '#fff', borderRadius: 999,
              fontSize: '0.72rem', minWidth: '1.25rem', textAlign: 'center',
              padding: '0 0.3rem', lineHeight: 1.6,
            }}>{n}</span>
          )}
        </button>

        {open && (
          <div style={{
            position: 'absolute', top: 'calc(100% + 0.4rem)', left: 0, zIndex: 300,
            background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12,
            boxShadow: '0 12px 32px rgba(0,0,0,0.16)', padding: '0.9rem 1rem',
            minWidth: 280, maxWidth: 'min(520px, 90vw)',
            maxHeight: '70vh', overflowY: 'auto',
          }}>
            {children}
            <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.9rem',
                          paddingTop: '0.7rem', borderTop: '1px solid #f0f0f0' }}>
              <button type="button" className="btn-secondary"
                      onClick={() => { onReset && onReset(); }}
                      disabled={n === 0}>
                すべて解除
              </button>
              <button type="button" className="btn-primary" onClick={() => setOpen(false)}>
                閉じる
              </button>
            </div>
          </div>
        )}
      </div>

      {/* 閉じていても、効いている条件は見えるようにする */}
      {chips.map((c, i) => (
        <span key={i}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '0.3rem',
                background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1d4ed8',
                borderRadius: 999, padding: '0.15rem 0.5rem 0.15rem 0.65rem',
                fontSize: '0.82rem', whiteSpace: 'nowrap',
              }}>
          {c.label}
          {c.onClear && (
            <button type="button" onClick={c.onClear} title="この条件を外す"
                    style={{ border: 'none', background: 'transparent', cursor: 'pointer',
                             color: '#1d4ed8', display: 'inline-flex', padding: 0 }}>
              <Icon name="x" size={13} />
            </button>
          )}
        </span>
      ))}
    </div>
  );
}
